"use strict";

exports.__esModule = true;
exports.onInitialClientRender = void 0;
var _camelCase = require("camel-case");
var _2 = require("./");
const onInitialClientRender = (_, pluginOptions) => {
  var _pluginOptions$attrib;
  const attributeName = (_pluginOptions$attrib = pluginOptions.attributeName) !== null && _pluginOptions$attrib !== void 0 ? _pluginOptions$attrib : _2.defaultOptions.attributeName;
  try {
    var _window$document$body;
    (_window$document$body = window.document.body.dataset) === null || _window$document$body === void 0 ? true : delete _window$document$body[(0, _camelCase.camelCase)(attributeName)];
  } catch (e) {}
};
exports.onInitialClientRender = onInitialClientRender;